import { makeStyles } from '@material-ui/styles';
import React from 'react';
import {
  List,
  ListItem,
  ListItemAvatar,
  Typography,
  ListItemText,
  Divider,
  CircularProgress,
  Card,
  CardContent,
  CardHeader,
  Backdrop
} from '@material-ui/core';
import { monthsTr } from 'src/utils/Common';
import { useTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars';

const useStyles = makeStyles(theme => ({
  root: {},
  divider: {
    backgroundColor: '#1D3343'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

const getAvatar = dateStr => {
  const date = new Date(dateStr);
  return [
    { id: 1, variant: 'h3', text: date.getDate() },
    { id: 2, variant: 'subtitle1', text: monthsTr[date.getMonth()] },
    { id: 3, variant: 'subtitle1', text: date.getFullYear() },
    {
      id: 4,
      variant: 'caption',
      text: date.toLocaleTimeString().substring(0, 5)
    }
  ];
};

function DigiportIssues({ issues, loading }) {
  const classes = useStyles();
  const { t } = useTranslation('profile');

  return (
    <Card>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardContent>
        <Typography className={classes.title} color="textPrimary">
          <b> {t('Cagrilarim')}</b>{' '}
        </Typography>
        <Scrollbars style={{ width: '100%', height: 200, align: 'center' }}>
          <List className={classes.root}>
            {issues.map(i => (
              <div key={i.id}>
                <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    <div>
                      {getAvatar(i.fields.created).map(a => (
                        <div key={a.id}>
                          <Typography
                            component="span"
                            variant={a.variant}
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {a.text}
                          </Typography>
                          <br />
                        </div>
                      ))}
                    </div>
                  </ListItemAvatar>
                  <ListItemText
                    size="3"
                    primary={`${i.key} - ${i.fields.customfield_11024?.requestType?.name}`}
                    secondary={
                      <div>
                        {t('Konu')} :{i.fields.summary}
                        <br />
                        {t('Aciklama')} :{i.fields.description}
                        <br />
                        {t('Durum')}:{i.fields.status.name}
                        <br />
                        {t('ilgili_Adi')} :{' '}
                        {i.fields.assignee && i.fields.assignee.displayName}
                        <br />
                        {t('ilgili_Email')} :{' '}
                        {i.fields.assignee && i.fields.assignee.emailAddress}
                        <br />
                        <a
                          href={`https://digiport.arcelik.com/servicedesk/customer/portal/1/${i.key}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t('Detaylar_icin_tiklayiniz')}
                        </a>
                      </div>
                    }
                  />
                </ListItem>
                <Divider className={classes.divider} />
              </div>
            ))}
          </List>
        </Scrollbars>
      </CardContent>
    </Card>
  );
}

export default DigiportIssues;
